@if (props) {
  @if (containsDuplicates()) {
    <div class="alert alert-warning">
      <p>Warning: Duplicate frequencies detected.</p>
    </div>
  }
  <mat-form-field>
    <mat-label>{{ props.label }}</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      [id]="id"
      [name]="field.name"
      [readonly]="props.readonly"
      [required]="props.required"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [placeholder]="props.placeholder"
      [errorStateMatcher]="matcher"
      [vectronicAllowedPattern]="'[0-9,.]'"
      (paste)="onPaste($event)"
    ></textarea>
    <mat-error>
      <formly-validation-message [field]="field"></formly-validation-message>
    </mat-error>
    @if (props['prefixText']) {
      <span matTextPrefix>{{ props['prefixText'] }}</span>
    }
    <span matSuffix>
      {{ props['suffixText'] }}
      <button
        mat-icon-button
        (click)="onClickAddFrequency()"
        matTooltip="Add Frequency"
        [disabled]="formControl.disabled || options?.formState?.devicesAmount <= frequencyLength"
      >
        <mat-icon>add</mat-icon>
      </button>
    </span>
  </mat-form-field>
}
